import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImac: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="imac, computer"><path d="M21.25 13.25H2.75M9.75 17.25H14.25V21.25H9.75V17.25ZM2.75 3.75H21.25V17.25H2.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconImac;
